import {useQuery} from "@tanstack/react-query";
import React from "react";
import {useTenantUserApi} from "../../api";
import {useTenantId} from "../../tenant";
import {ignoreNotFound} from "../../utils/ignoreNotFound";
import {queryKeys} from "../../utils/queryKeys";
import {UserLinkChip} from "../user/UserChip";

interface ActorChipProps {
	actor?: string;
}

export function ActorChip({actor}: Readonly<ActorChipProps>) {
	const tenantId = useTenantId();
	const {getUser} = useTenantUserApi();

	const {data} = useQuery(
		queryKeys.tenantUser(tenantId, actor ?? ""),
		() => ignoreNotFound(() => getUser(actor!)),
		{
			enabled: !!actor,
			staleTime: 5 * 60_000,
			retry: false,
		},
	);

	return <UserLinkChip user={data?.user} fallback={actor} />;
}
